import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import { getApiData } from '../apiFunctions/getApiData';
import { downloadFile } from '../apiFunctions/downloadFile';
import { ModuleInformation } from '../types/ModuleInformation';
import * as Constants from '../constants';
import { LoadingSpinner } from './generic/LoadingSpinner';
import { ErrorAlert } from './generic/ErrorAlert';
import { OkButtonSpinner } from './generic/OkButtonSpinner';

export const CheckModuleKeyLicense: React.FC = props => {
    const [moduleKey, setModuleKey] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [moduleInformation, setModuleInformation] = useState<ModuleInformation>();

    const setData = (moduleInformation: ModuleInformation) => {
        if (!moduleInformation.products || moduleInformation.products.length === 0) {
            setErrorMessage("Module key not found or no valid product connected to module key.");
            setModuleInformation(undefined);
        } else {
            setErrorMessage("");
            setModuleInformation(moduleInformation);
        }
    }

    const getModuleInformation = () => {
        getApiData(Constants.API_MODULE_INFORMATION_URL + "/" + encodeURIComponent(moduleKey), setLoading, setData, setErrorMessage);
    }

    const downloadCertificate = (moduleKey: string, productId: number) => {
        setDownloading(true);
        downloadFile(Constants.API_MODULE_INFORMATION_URL + '/certificate/' + moduleKey + "/" + productId,
            setDownloading, setErrorMessage, () => { }, 'LicenseCertificate_' + moduleKey + '.pdf');
    }

    return <Form className="mt-3">
        {loading && <LoadingSpinner />}
        {!loading && errorMessage !== "" && <ErrorAlert errorMessage={errorMessage} />}

        {!loading && <Form className="mt-3">
            <Form.Group className="mb-3" controlId="moduleKey">
                <Form.Control type="text" placeholder="00123456"
                    defaultValue={moduleKey}
                    onChange={(e: any) => {
                        setModuleKey(e.currentTarget.value);
                    }} />
            </Form.Group>

            <Button className="button" disabled={moduleKey.length !== 8 || !/^[09]\d+$/.test(moduleKey)} onClick={() => { getModuleInformation(); }}>
                Check
            </Button>
        </Form>}

        {!loading && moduleInformation &&
            <React.Fragment>
                {moduleInformation.products.map(product => {
                    return <Alert className="mt-3">
                        <p className="fw-bold">{product.productName}</p>
                        <Button className="button" onClick={() => { downloadCertificate(moduleKey, product.productId); }}>
                            Download certificate {downloading && <OkButtonSpinner />}
                        </Button>
                    </Alert>;
                })}
            </React.Fragment>
        }
    </Form>;
}